import { Download, ShieldCheck, Timer, Star } from "lucide-react";
import { Reveal } from "./Reveal";

const trustItems = [
    { icon: ShieldCheck, label: "Safe & Secure" },
    { icon: Timer, label: "Setup in 2 Minutes" },
    { icon: Star, label: "4.8 Rated by Drivers" },
];

export default function DownloadCTA() {
    return (
        <section id="download" data-testid="download-section" className="px-6 pb-16 md:pb-32 lg:px-10">
            <Reveal>
                <div className="relative mx-auto max-w-7xl overflow-hidden rounded-[2.5rem] bg-ink px-8 py-12 md:px-16 md:py-24">
                    <span
                        aria-hidden="true"
                        className="pointer-events-none absolute -bottom-10 right-4 select-none font-mono text-[9rem] font-bold leading-none text-white/[0.04] md:text-[15rem]"
                    >
                        32ms
                    </span>

                    <p className="font-mono text-[11px] uppercase tracking-[0.18em] text-brand">
                        Ready to transform your earnings?
                    </p>
                    <h2 className="mt-5 max-w-2xl font-display text-4xl font-bold tracking-tight text-paper md:text-6xl">
                        Stop missing orders. Start earning more.
                    </h2>
                    <p className="mt-6 max-w-md text-base leading-relaxed text-white/60">
                        Every second you wait, another driver is accepting the orders you could
                        have had. Join 10,000+ smart drivers who already use RapidClick to maximize
                        their daily income.
                    </p>

                    <div className="mt-8 flex flex-wrap items-center gap-x-6 gap-y-2">
                        {trustItems.map((t) => (
                            <span
                                key={t.label}
                                className="flex items-center gap-2 text-xs font-medium text-white/70"
                            >
                                <t.icon size={14} className="text-brand" />
                                {t.label}
                            </span>
                        ))}
                    </div>

                    <a
                        href="/rapidclick.apk"
                        download
                        data-testid="download-apk-button"
                        className="group mt-10 inline-flex items-center gap-3 rounded-full bg-brand px-8 py-4 text-sm font-bold text-white transition-transform duration-300 hover:scale-[1.05]"
                    >
                        <Download
                            size={17}
                            className="transition-transform duration-300 group-hover:translate-y-0.5"
                        />
                        Download RapidClick APK — It's Free
                    </a>
                    <p className="mt-5 font-mono text-[10px] uppercase tracking-[0.18em] text-white/40">
                        Android 8.0+ · 5 MB download
                    </p>
                    <p className="mt-4 text-[11px] text-white/35">
                        By downloading, you agree to our{" "}
                        <a href="/terms" className="underline underline-offset-2 hover:text-white/60" data-testid="cta-terms-link">
                            Terms of Service
                        </a>{" "}
                        and{" "}
                        <a href="/privacy" className="underline underline-offset-2 hover:text-white/60" data-testid="cta-privacy-link">
                            Privacy Policy
                        </a>
                        .
                    </p>
                </div>
            </Reveal>
        </section>
    );
}
